import { trackError } from 'helpers/ErrorUtils';

// Don't use these directly unless you really need to.  Otherwise you should go through the
// localStorage reducer as it puts the data into redux and also saves to/ hydrates from localStorage automatically
export const loadFromLocalStorage = key => {
  try {
    const serializedData = window.localStorage.getItem(key);
    if (serializedData === null) {
      return undefined;
    }
    return JSON.parse(serializedData);
  } catch (err) {
    trackError('NON-FATAL', 'Local storage not enabled for this user', err);
    return undefined;
  }
};

export const saveToLocalStorage = (key, data) => {
  try {
    const serializedData = JSON.stringify(data);
    window.localStorage.setItem(key, serializedData);
  } catch (err) {
    trackError('NON-FATAL', 'Local storage not enabled for this user', err);
  }
};
